module.exports = __webpack_public_path__ + "img/saum_brillantgelb_farbnr119.e03cf099.jpg";